import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

// admin store
import CodeMngt from './modules/admin/codeMngt.js'
import MedicineMngt from './modules/admin/medicineMngt.js'
import MedWrhsMngt from './modules/admin/medWrhsMngt.js'
import NoticeMngt from './modules/admin/noticeMngt.js'
import WrapperMngt from './modules/admin/wrapperMngt.js'
import DictionaryMngt from './modules/admin/dictionaryMngt.js'
import commonStore from './modules/admin/commonStore.js'
import PromiseMngt from './modules/admin/promiseMngt.js'
import promiseWhrsMngt from './modules/admin/promiseWhrsMngt.js'
import userMngt from './modules/admin/userMngt.js'
import orderPaymentMngt from './modules/admin/orderPaymentMngt.js'


// user store
import clinicDoctorInfo from './modules/user/clinicDoctorInfo.js'
import applicationInfo from './modules/user/applicationInfo.js'
import promiseGoodsInfo from './modules/user/promiseGoodsInfo.js'
import tangjunInfo from './modules/user/tangjunInfo.js'
import paymentInfo from './modules/user/paymentInfo.js'

//common
import detailSearchInfo from './modules/common/detailSearchInfo.js'
import codeMngt from './modules/admin/codeMngt.js';

const store = new Vuex.Store({
    modules: {
        codeMngt: CodeMngt,
        medicine: MedicineMngt,
        medWrhs: MedWrhsMngt,
        notice: NoticeMngt,
        wrapper: WrapperMngt,
        dictionary: DictionaryMngt,
        commonStore: commonStore,
        clinicDoctorInfo: clinicDoctorInfo,
        applicationInfo : applicationInfo,
        promise : PromiseMngt,
        promiseWhrs : promiseWhrsMngt,
        promiseGoodsInfo : promiseGoodsInfo,
        tangjunInfo : tangjunInfo,
        userMngt : userMngt,
        orderPaymentMngt : orderPaymentMngt,
        detailSearchInfo : detailSearchInfo,
        paymentInfo : paymentInfo
    },
    plugins: [
        //주목! : 여기에 쓴 모듈만 저장됩니다.
        createPersistedState({
          paths: ['commonStore','clinicDoctorInfo','apllicationInfo','promiseGoodsInfo','detailSearchInfo','detailSearchInfo'],
        })
      ]
})

export default store